@if (shops?.length) {
  <div class="h-100" #modal>
    @if (!isMobile) {
      <div class="modal-header text-center pb-2">
        <h4 class="modal-title ml-auto mr-auto">{{ 'ALPY_MAP_MODAL.whereToFind' | alpitranslate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeMe()">
          <app-icon name="cross" />
        </button>
      </div>
    }
    <div class="modal-body p-0 px-lg-3">
      <div class="map-container">
        @if (!isMobile) {
          <div class="hotelSearch" *abTestVersion="'v2'; scope: 'hotelNavigation'">
            @if (selectedHotelService.selectedHotel()) {
              @defer (when selectedHotelService.selectedHotel()) {
                <app-hotel
                  [selectedHotel]="selectedHotelService.selectedHotel()"
                  [dontNavigate]="true"
                  (showHotel)="centerOnHotel()"
                  (removeHotel)="changeHotelSelection()" />
              }
            } @else {
              <button
                type="button"
                class="btn btn-primary"
                (click)="$event.stopPropagation(); showHotelSearch = true">
                {{ 'ALPY_MAP_MODAL.searchHotelChoice' | alpitranslate }}
              </button>
            }
            @defer (when showHotelSearch) {
              @if (showHotelSearch && shops?.length) {
                <app-hotel-selection
                  [shops]="shops"
                  (closeMe)="showHotelSearch = false"
                  (selectedHotel)="changeHotelSelection($event)"
                  style="top: 35px; left: 0; transform: translateX(0)" />
              }
            }
          </div>
        }
        <app-map [shops]="shops" [mapType]="mapType" class="map" #map></app-map>
      </div>
      @if (isMobile) {
        <button type="button" class="close p-2" aria-label="Close" (click)="closeMe()">
          <app-icon name="cross" />
        </button>
      }
      <div class="text-center button-container mt-3 px-5">
        <button type="button" class="btn btn-primary btn-close-button" (click)="closeMe()">
          <app-icon name="arrowLeft" class="btn-text mr-2" width="1.5rem" height="1.5rem" />
          <span class="btn-text d-inline-block">{{ 'ALPY_MAP_MODAL.close' | alpitranslate }}</span>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="close-button" (click)="closeMe()"><app-icon name="cross" /></div>
  Loading....
}
